import status from "../../config/status.json";
import { TextField, MenuItem } from "@mui/material";

export default function Status({category, label, value, onChange, required}){

    const categoryStatus = status.filter(s => s.category === category)

    const findStatus = id => status.find(s => s.category === category && s.id === id)

    const val = categoryStatus.find(s => s.id === value?.id)?.id || ''

    return <TextField
        label={label || 'Profession'}
        select
        value={val}
        onChange={e => onChange( findStatus(e.target.value) )}
        required={required ? true : false}
        size='small'
    >
        {categoryStatus.map(s => 
            <MenuItem value={s.id} key={s.id}>{s.title}</MenuItem>
        )}
    </TextField>
}